<div class="smooth-scrolling">

    <section class="trending-Main">
        <div class="heading">
          <h2>what's<span>trending?</span></h2>
          <div class="sub-title">Here, there and everywhere</div>
        </div>
    </section>

    <section class="blog-filter-panel mb-3">
        <div class="row align-items-center justify-content-center">
          <div class="col-lg-9 rightSide">
            <div class="blog-nav">
              <ul class="blog-nav-scrollbar scrollbar">
                <li *ngFor="let cat of mCategoryResponseModal?.data; let i = index" (click)="openBlogList(cat?.id)"><a [ngStyle]="cat?.color && cat?.color == '#fff' ? {'background': cat?.color , 'color' : '#000'} : cat?.color  ? {'background': cat?.color , 'color' : '#fff'} : {'background': '#d3d3d3' , 'color' : '#000'} " class="c-orange">{{cat?.name}}</a></li>
              </ul>
            </div>
          </div>
        </div>
      </section>
     <section class="trending-Main" *ngIf="trendingBlogs && trendingBlogs.length > 0">
      <div class="blog-slides-padding">
        <div class="blog-Slides scrollbar px-0">
          <app-blogs [categoryList]="mCategoryResponseModal?.data" *ngFor="let trendingBlog of trendingBlogs; let i = index" [blog]="trendingBlog"></app-blogs>
        </div>
      </div>
    </section>

     <div *ngFor="let blogsCat of allTrendingBlogsCategoryWise; let i = index">
      <section *ngIf="blogsCat && blogsCat.blogs && blogsCat.blogs.length > 0"  class="pink-box" [style]="'background:' + blogsCat?.category?.color">
          <div class="heading">
              <h4><sup>{{blogsCat?.category?.name?.toUpperCase()}}</sup><span><sub>trending</sub></span></h4>
              <div class="sub-title">Trust us, it's not that complicated.</div>
            </div>
              <div class="row">
                  <div *ngFor="let blog of blogsCat?.blogs; let i = index"   class="col-xxl-4 col-xl-5 col-lg-6 col-12 mb-4">
                      <div class="blog-list-text-detail">
                          <div class="blog-detail">
                              <div class="blog-detail-text">
                                  <div class="lable-and-tital">
                                      <span class="lable-new">New</span>
                                      <h5>{{blog?.title}}</h5>
                                  </div>

                                <span>Why you shouldn't think of</span>
                                <p>{{blog?.short_description}}</p>
                              </div>
                          </div>
                          <div class="blog-list-img">
                            <img [src]="blog  && getBlogThumbnail(blog.imageList)" />
                          </div>
                      </div>
                  </div>
              </div>
      </section>
     </div>
</div>
<app-footer-bg></app-footer-bg>